﻿'use strict';
var Backbone = require('backbone');
var MailDeliveryPreference = require('../models/mailDeliveryPreference');

module.exports = Backbone.Collection.extend({
    model: MailDeliveryPreference
});